import React from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { LockFill } from 'react-bootstrap-icons';
import './TemplateCard.css';

interface TemplateCardProps {
  title: string;
  description?: string;
  icon?: string;
  onClick?: () => void;
  isSelected?: boolean;
  isDisabled?: boolean;
  disabledTooltip?: string;
}

const TemplateCard: React.FC<TemplateCardProps> = ({
  title,
  description,
  icon,
  onClick,
  isSelected = false,
  isDisabled = false,
  disabledTooltip = 'Upgrade to Pro to unlock this template'
}) => {
  const handleClick = () => {
    if (!isDisabled && onClick) {
      onClick();
    }
  };

  const cardContent = (
    <Card
      className={`template-card ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
      onClick={handleClick}
      style={{
        cursor: isDisabled ? 'not-allowed' : (onClick ? 'pointer' : 'default'),
        backgroundColor: isDisabled ? '#E9ECEF' : undefined
      }}
    >
      <Card.Body className="d-flex flex-column">
        <div className="template-card-icon">
          {isDisabled ? (
            <LockFill size={22} style={{ color: '#6c757d', marginBottom: '20px' }} />
          ) : icon ? (
            <img
              src={require(`../assets/templates/${icon}.png`)}
              alt={`${title} icon`}
              style={{ width: '55px', height: '40px', objectFit: 'contain' }}
            />
          ) : null}
        </div>
        <p className="template-card-title">{title}</p>
        {description && (
          <p className="template-card-description text-muted small mt-2">
            {description}
          </p>
        )}
      </Card.Body>
    </Card>
  );

  if (isDisabled) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id={`tooltip-${title}`}>{disabledTooltip}</Tooltip>}
      >
        <div>{cardContent}</div>
      </OverlayTrigger>
    );
  }

  return cardContent;
};

export default TemplateCard;